import { DataTableDefaultCellTemplates, DataTableEventArgs, ITableColumn } from "../../../../components";
import { CustomerPolicyDetailLabels as cstPolicyAdditionalInterestsLabel } from '../../../../shared/util/label';

export default class CustomerAdditionalInterestsTableConfig {
    private handleRowExpandToggle(
        dtEventArgs: DataTableEventArgs,
        onRowClick: any,
        onChevronClose: () => void
    ) {
        const { rowData, dataTableState } = dtEventArgs;
        const rowKey = rowData[dataTableState.dataTable.keyColumnName];
        let currentRowState = dataTableState.rowsState[rowKey];
        if (!currentRowState) {
            currentRowState = { expanded: true };
        } else {
            currentRowState = { ...currentRowState, expanded: !currentRowState.expanded };
        }
        dataTableState.rowsState[rowKey] = { expanded: currentRowState.expanded };
        dataTableState.dataTable.setExpandedRowId(currentRowState.expanded ? rowKey : null);
        if (currentRowState.expanded) {
            onRowClick(rowData, dtEventArgs.column);
        } else {
            onChevronClose();
        }
    }

    getAdditionalInterestsTableColumns = (
        onRowClick: any,
        onChevronClose: () => void,
        onRowDeleteClick?: any,
        tabIndex?: number
    ): ITableColumn[] => {
        return [
            {
                tabIndex: tabIndex,
                width: '5%',
                maxWidth: '5%',
                cellTemplate: DataTableDefaultCellTemplates.RowExpander.CellTemplate,
                cellClickHandler: (dtEventArgs: DataTableEventArgs) => {
                    this.handleRowExpandToggle(dtEventArgs, onRowClick, onChevronClose);
                },
                cellTdClassName: 'expander-cell-td',
                onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
                    const { eventData } = dtEventArgs;
                    if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
                        this.handleRowExpandToggle(dtEventArgs, onRowClick, onChevronClose);
                    }
                }
            },
            {
                header: cstPolicyAdditionalInterestsLabel.ATTACH_TYPE,
                field: "attachTypeValue",
                width: "10%",
                cellTemplate: (rowData) => <span title={rowData.attachTypeValue}>{rowData.attachTypeValue}</span>
            },
            {
                header: cstPolicyAdditionalInterestsLabel.INTEREST_TYPE,
                field: "interestTypeValue",
                width: "10%",
                cellTemplate: (rowData) => <span title={rowData.interestTypeValue}>{rowData.interestTypeValue}</span>
            },
            {
                header: cstPolicyAdditionalInterestsLabel.NAME,
                field: "name",
                width: "15%",
                cellTemplate: (rowData) => {
                    const computedName = (rowData.name1 && rowData.name2)
                        ? `${rowData.name1} ${rowData.name2}`
                        : (rowData.name1 || rowData.name2 || "");
                    return <span title={computedName}>{computedName}</span>;
                }
            },
            {
                header: cstPolicyAdditionalInterestsLabel.ADDRESS,
                field: "address",
                width: "20%",
                cellTemplate: (rowData) => {
                    const computedAddress = (rowData.address1 && rowData.address2)
                        ? `${rowData.address1} ${rowData.address2}`
                        : (rowData.address1 || rowData.address2 || "");
                    return <span title={computedAddress}>{computedAddress}</span>;
                }
            },
            {
                header: cstPolicyAdditionalInterestsLabel.CITY,
                field: "city",
                width: "8%",
                cellTemplate: (rowData) => <span title={rowData.city}>{rowData.city}</span>
            },
            {
                header: cstPolicyAdditionalInterestsLabel.STATE,
                field: "state",
                width: "8%",
                cellTemplate: (rowData) => <span title={rowData.state}>{rowData.state}</span>
            },
            {
                header: cstPolicyAdditionalInterestsLabel.ZIP_CODE,
                field: "zip",
                width: "8%",
                cellTemplate: (rowData) => <span title={rowData.zip}>{rowData.zip}</span>
            },
            {
                header: cstPolicyAdditionalInterestsLabel.LOAN_NUMBER,
                field: "referenceNumber",
                width: "8%",
                cellTemplate: (rowData) => <span title={rowData.referenceNumber}>{rowData.referenceNumber}</span>
            },
             {
                header: cstPolicyAdditionalInterestsLabel.RANK,
                field: "rank",
                width: "5%",
                cellTemplate: (rowData) => <span title={rowData.rank}>{rowData.rank}</span>
            },
            {
                header: cstPolicyAdditionalInterestsLabel.PAYOR,
                field: "isPayor",
                width: "7%",
                cellTemplate: (rowData) => {
                    let displayValue = "";
                    if (rowData.isPayor === true) displayValue = "Yes";
                    else if (rowData.isPayor === false) displayValue = "No";
                    // if null or undefined, displayValue remains ""
                    return <span title={displayValue}>{displayValue}</span>;
                }
            },
            {
                tabIndex: tabIndex,
                width: '5em',
                maxWidth: '5em',
                cellTemplate: DataTableDefaultCellTemplates.DeleteCellTemplate.CellTemplate,
                cellClickHandler: (dtEventArgs: DataTableEventArgs) => onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column),
                onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
                    const { eventData } = dtEventArgs;
                    if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
                        onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column);
                    }
                }
            }
        ];
    }

}
